import { CopyToClipboard, Icon, Scrollbar } from '@aibees/shared/components';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import * as SX from './sx';
import { ValidationInfoItemProps } from './types';

export const ValidationInfoItem = ({
  title,
  items,
}: ValidationInfoItemProps) => {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Typography
          variant="body3"
          fontWeight={400}
          color="grey.700"
          lineHeight={1.7}
        >
          {`${title} (${items.length})`}
        </Typography>
        {items.length > 0 && (
          <CopyToClipboard
            component={() => (
              <Button
                variant="text"
                color="default"
                endIcon={<Icon name="copy" size={12} color="common.black" />}
                size="xsmall"
              >
                <Typography
                  variant="body4"
                  fontWeight={500}
                  color="common.black"
                >
                  Copy All
                </Typography>
              </Button>
            )}
            value={items.join('\n')}
          />
        )}
      </Box>
      <Card variant="outlined" sx={SX.card}>
        <Scrollbar sx={SX.scrollbar}>
          <CardContent sx={SX.itemsContainer}>
            {items.map((item) => (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                key={item}
                sx={SX.validationInfoItem}
              >
                <Typography
                  variant="body3"
                  fontWeight={400}
                  color="common.black"
                >
                  {item}
                </Typography>
                <Box>
                  <CopyToClipboard
                    value={item}
                    icon={<Icon name="copy" size={18} />}
                    className={'copy-to-clipboard-validation-info-item'}
                  />
                </Box>
              </Box>
            ))}
          </CardContent>
        </Scrollbar>
      </Card>
    </Box>
  );
};
